// extracted by mini-css-extract-plugin
module.exports = {"searchWrapper":"SearchInputWithCount_searchWrapper__8pekF","searchInput":"SearchInputWithCount_searchInput__tvyja","countText":"SearchInputWithCount_countText__aeBpl"};